export const NAMESPACE = "@global-mediation/globalmediation-admin/";